import { FilterProvider } from "./contexts/FilterContext";
import { ModalProvider } from "./contexts/ModalContext";
import Initial from "./templates/initial";

export default function Dashboard2() {
    return (
        <FilterProvider>
            <ModalProvider>
                <Initial />
            </ModalProvider>
        </FilterProvider>
    )
}